import { render, staticRenderFns } from "./ConsentFormPerviewModal.vue?vue&type=template&id=980c1094&scoped=true"
import script from "./ConsentFormPerviewModal.vue?vue&type=script&lang=js"
export * from "./ConsentFormPerviewModal.vue?vue&type=script&lang=js"
import style0 from "./ConsentFormPerviewModal.vue?vue&type=style&index=0&id=980c1094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980c1094",
  null
  
)

export default component.exports